export default __webpack_public_path__ + "./assets/apple-touch-icon.jpeg";